__turbopack_context__.v({
  "container": "FloatingLabel-module__XB0UFG__container",
  "container__error_message": "FloatingLabel-module__XB0UFG__container__error_message",
  "container__input": "FloatingLabel-module__XB0UFG__container__input",
});
